import React from "react";
import { useField } from "formik";
import styled from "styled-components";
import { SelectPropsWithoutRef } from "react-html-props";
import FieldErrorMessage from "./FieldErrorMessage";
import FieldLabel from "./FieldLabel";
import FieldHelpText from "./FieldHelpText";
import SelectInput from "./SelectInput";

const SelectField = (props: Props) => {
  const {
    label,
    helpText,
    hiddenLabel,
    prefixDisplay,
    children,
    ...otherProps
  } = props;
  const [field, meta] = useField<string>(props);

  const showError = Boolean(meta.touched && meta.error);
  const htmlFor = otherProps.id || otherProps.name;

  const value = field.value || "";

  return (
    <FieldWrapper>
      <FieldLabel htmlFor={htmlFor} visuallyHidden={hiddenLabel}>
        {label}
        {helpText && <FieldHelpText>{helpText}</FieldHelpText>}
      </FieldLabel>
      <SelectInput
        id={htmlFor}
        {...field}
        {...otherProps}
        value={value}
        error={showError}
      >
        {children}
      </SelectInput>
      <FieldErrorMessage name={otherProps.name} />
    </FieldWrapper>
  );
};

interface Props extends SelectPropsWithoutRef {
  label?: string;
  name: string;
  helpText?: string;
  hiddenLabel?: boolean;
  prefixDisplay?: React.ReactNode;
}

const FieldWrapper = styled.div`
  font-family: ${({ theme }) => theme.font};
  margin-bottom: 1.5rem;
`;

export default SelectField;
